import React, { useEffect, useState } from 'react';
import { GoalCard } from './components/GoalCard';
import { StickyNote } from './components/StickyNote';
import { SketchPad } from './components/SketchPad';
import { BottomNav } from './components/BottomNav';
export function App() {
  const [progress, setProgress] = useState(0);
  const [goals, setGoals] = useState([{
    id: 1,
    title: 'Ship the PDF editor landing page',
    subtitle: 'final copy + hero polish',
    isCompleted: false
  }, {
    id: 2,
    title: 'Call investors',
    subtitle: 'follow up with 3 from Tuesday',
    isCompleted: false
  }, {
    id: 3,
    title: 'Read 30 mins',
    subtitle: 'Finish chapter 4 — Shoe Dog',
    isCompleted: true
  }]);
  // Calculate day progress based on current hour
  useEffect(() => {
    const updateProgress = () => {
      const now = new Date();
      const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const msInDay = 24 * 60 * 60 * 1000;
      const elapsed = now.getTime() - startOfDay.getTime();
      const percentage = Math.min(100, Math.max(0, elapsed / msInDay * 100));
      setProgress(percentage);
    };
    updateProgress();
    const interval = setInterval(updateProgress, 60000); // Update every minute
    return () => clearInterval(interval);
  }, []);
  const toggleGoal = (id: number) => {
    setGoals(goals.map(g => g.id === id ? {
      ...g,
      isCompleted: !g.isCompleted
    } : g));
  };
  const todayDate = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric'
  });
  return <div className="min-h-screen bg-app-bg text-white pb-24 selection:bg-app-accent/30 font-sans" data-id="element-0">
      {/* Top Progress Bar */}
      <div className="fixed top-0 left-0 right-0 h-1.5 bg-app-card z-50" data-id="element-1">
        <div className="h-full bg-app-accent transition-all duration-1000 ease-out" style={{
        width: `${progress}%`
      }} data-id="element-2" />
      </div>
      <div className="fixed top-2 right-4 z-50 flex items-center gap-2" data-id="element-3">
        <span className="text-[9px] font-syne font-bold tracking-widest text-gray-500" data-id="element-4">
          DAY PROGRESS
        </span>
        <span className="text-[10px] font-mono text-app-accent" data-id="element-5">
          {Math.round(progress)}%
        </span>
      </div>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-16 sm:pt-24" data-id="element-6">
        {/* Header */}
        <header className="mb-12 sm:mb-16" data-id="element-7">
          <h1 className="font-syne font-extrabold text-4xl sm:text-5xl tracking-tight mb-2" data-id="element-8">
            AmbitionBoard<span className="text-app-accent" data-id="element-9">.</span>
          </h1>
          <p className="text-gray-400 font-medium tracking-wide uppercase text-sm" data-id="element-10">
            {todayDate}
          </p>
        </header>

        {/* Morning Intentions */}
        <section className="mb-16 sm:mb-24" data-id="element-11">
          <div className="flex items-center gap-3 mb-6" data-id="element-12">
            <h2 className="font-syne font-bold text-sm tracking-[0.2em] text-gray-500" data-id="element-13">
              MORNING INTENTIONS
            </h2>
            <div className="flex-1 h-px bg-app-border/50" data-id="element-14" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-15">
            {goals.map(goal => <GoalCard key={goal.id} title={goal.title} subtitle={goal.subtitle} isCompleted={goal.isCompleted} onToggle={() => toggleGoal(goal.id)} data-id="element-16" />)}
          </div>
        </section>

        {/* Idea Canvas */}
        <section className="mb-12" data-id="element-17">
          <div className="flex items-center gap-3 mb-6" data-id="element-18">
            <h2 className="font-syne font-bold text-sm tracking-[0.2em] text-gray-500" data-id="element-19">
              IDEA CANVAS
            </h2>
            <div className="flex-1 h-px bg-app-border/50" data-id="element-20" />
          </div>

          <div className="relative w-full h-[300px] sm:h-[400px] bg-[#0a0a0d] border border-app-border/30 rounded-2xl overflow-hidden mb-6 bg-[radial-gradient(#2A2A35_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-21">
            {/* Sample Sticky Notes */}
            <StickyNote text="rebrand color palette?" rotation={-3} colorClass="bg-[#1e1e24]" x={20} y={40} data-id="element-22" />
            <StickyNote text="talk to Sam re: API" rotation={2} colorClass="bg-[#1a1a20]" x={180} y={80} data-id="element-23" />
            <StickyNote text="pricing: usage-based?" rotation={-5} colorClass="bg-app-accent/20 border border-app-accent/30 text-app-accent" x={80} y={160} data-id="element-24" />
            <StickyNote text="new logo idea ↓" rotation={4} colorClass="bg-[#22222a]" x={260} y={200} data-id="element-25" />

            <div className="absolute bottom-4 right-4 text-xs font-syne text-gray-600 pointer-events-none" data-id="element-26">
              drag notes around
            </div>
          </div>

          {/* Sketch Area */}
          <SketchPad data-id="element-27" />
        </section>
      </main>

      <BottomNav data-id="element-28" />
    </div>;
}